(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('ss-quiz')) return;

  /* ── Scents: edit names, lines, colors and result copy here ── */
  var SCENTS = {
    amber:    { key: 'amber riviera',   name: 'Amber Riviera',   meta: 'Unisex, amber and woody',     color: '#6A3835', moment: 'Golden hour on a terrace, the stone still warm from the day.' },
    sicilian: { key: 'sicilian smoke',  name: 'Sicilian Smoke',  meta: 'For him, woody and smoky',    color: '#2B2724', moment: 'A Sicilian shore at night, driftwood burning low.' },
    coastal:  { key: 'coastal noir',    name: 'Coastal Noir',    meta: 'For him, woody and aromatic', color: '#2C3A43', moment: 'Salt air and cedar after a late swim.' },
    wild:     { key: 'wild tramontana', name: 'Wild Tramontana', meta: 'Unisex, aromatic and fresh',  color: '#6E7A6B', moment: 'The north wind sweeping the hills clean in the morning.' },
    portofino:{ key: 'portofino rose',  name: 'Portofino Rose',  meta: 'For her, floral and warm',    color: '#A8556A', moment: 'Evening in the harbour, roses on the table.' },
    amalfi:   { key: 'amalfi bloom',    name: 'Amalfi Bloom',    meta: 'For her, floral and woody',   color: '#C98A5E', moment: 'A morning on the Amalfi coast, blossom over the path.' },
    tuscan:   { key: 'tuscan wind',     name: 'Tuscan Wind',     meta: 'Aromatic and warm',           color: '#9C8348', moment: 'Late summer in Tuscany, lavender on the air through an open window.' }
  };
  /* Tie-breaker order: first wins when scores are equal */
  var ORDER = ['amber', 'portofino', 'sicilian', 'amalfi', 'coastal', 'tuscan', 'wild'];

  /* ── Questions: "s" adds points per scent, "f" sets the format ── */
  var QUESTIONS = [
    { q: 'Who is it for?', opts: [
      { t: 'For him', s: { sicilian: 4, coastal: 4, amber: 2, wild: 2, tuscan: 1, portofino: -3, amalfi: -3 } },
      { t: 'For her', s: { portofino: 4, amalfi: 4, tuscan: 3, amber: 2, wild: 1, sicilian: -3, coastal: -3 } },
      { t: 'Either, or both', s: { amber: 3, wild: 3, tuscan: 2, sicilian: 1, coastal: 1, portofino: 1, amalfi: 1 } }
    ]},
    { q: 'Which pulls you in?', opts: [
      { t: 'Warm and golden', s: { amber: 3, tuscan: 2, portofino: 1 } },
      { t: 'Smoky and woody', s: { sicilian: 3, coastal: 2, amber: 1 } },
      { t: 'Fresh and clean', s: { wild: 3, coastal: 2, amalfi: 1 } },
      { t: 'Soft and floral', s: { portofino: 3, amalfi: 3, tuscan: 1 } }
    ]},
    { q: 'When will you wear it most?', opts: [
      { t: 'Sunny days out', s: { wild: 2, amalfi: 2, coastal: 1 } },
      { t: 'Work and every day', s: { coastal: 2, amalfi: 1, wild: 1, tuscan: 1 } },
      { t: 'Evenings out', s: { amber: 2, sicilian: 2, portofino: 2 } },
      { t: 'Nights I want to be remembered', s: { amber: 2, tuscan: 2, sicilian: 1, portofino: 1 } }
    ]},
    { q: 'How do you like to wear fragrance?', opts: [
      { t: 'A few sprays every morning', f: 'spray' },
      { t: 'Close to the skin, just for me', f: 'oil' },
      { t: 'In my pocket for touch-ups', f: 'solid' },
      { t: 'I want to try all three', f: 'set' }
    ]}
  ];

  var FMT_NAME = { spray: 'spray', oil: 'roll-on oil', solid: 'solid', set: 'set' };
  var FALLBACK = ['spray', 'set', 'oil', 'solid'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  class SsQuiz extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var el = this;

      var items = [];
      try { items = JSON.parse(this.querySelector('[data-ssq-products]').textContent); } catch (e) {}
      this.products = {};
      items.forEach(function (p) {
        var byKey = el.products[p.key] = el.products[p.key] || {};
        var cur = byKey[p.fmt];
        if (!cur || (!cur.available && p.available)) byKey[p.fmt] = p;
      });

      this.step = 0;
      this.answers = [];
      this.busy = false;

      this.$('[data-ssq-start]').addEventListener('click', function () { el.start(); });
      this.$('[data-ssq-back]').addEventListener('click', function () {
        if (el.step > 0) { el.step--; el.answers.length = el.step; el.render(); }
      });

      var form = this.$('.ssq__form');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('button[type="submit"]');
          btn.disabled = true;
          btn.textContent = 'Sending…';
          var tags = el.$('[data-ssq-tags]');
          if (tags && el.result) tags.value = 'scent-finder,scent-' + SCENTS[el.result.top].key.replace(/ /g, '-');
          fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
            .catch(function () {})
            .then(function () { el.showResult(); });
        });
      }
      var skip = this.$('[data-ssq-skip]');
      if (skip) skip.addEventListener('click', function () { el.showResult(); });

      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-ssq-retake]')) el.start();
      });

      this.show('intro');
    }

    $(s) { return this.querySelector(s); }

    show(name) {
      this.querySelectorAll('.ssq__screen').forEach(function (s) { s.hidden = s.dataset.screen !== name; });
      var top = this.getBoundingClientRect().top;
      if (top < 0) this.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    start() {
      this.step = 0;
      this.answers = [];
      this.show('quiz');
      this.render();
    }

    render() {
      var el = this;
      var Q = QUESTIONS[this.step];
      this.busy = false;
      this.$('[data-ssq-count]').textContent = (this.step + 1) + ' of ' + QUESTIONS.length;
      this.$('[data-ssq-bar]').style.width = ((this.step + 1) / QUESTIONS.length * 100) + '%';
      this.$('[data-ssq-back]').disabled = this.step === 0;
      var qEl = this.$('[data-ssq-q]');
      qEl.textContent = Q.q;
      var box = this.$('[data-ssq-opts]');
      box.innerHTML = '';
      Q.opts.forEach(function (o, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ssq__opt';
        b.textContent = o.t;
        b.addEventListener('click', function () { el.pick(i, b); });
        box.appendChild(b);
      });
      qEl.focus({ preventScroll: true });
    }

    pick(i, btn) {
      if (this.busy) return;
      this.busy = true;
      btn.classList.add('is-picked');
      this.answers[this.step] = i;
      var el = this;
      setTimeout(function () {
        el.step++;
        if (el.step < QUESTIONS.length) el.render();
        else el.finish();
      }, 200);
    }

    finish() {
      var scores = {};
      ORDER.forEach(function (k) { scores[k] = 0; });
      var fmt = 'spray';
      this.answers.forEach(function (ai, qi) {
        var o = QUESTIONS[qi].opts[ai];
        if (o.f) fmt = o.f;
        if (o.s) Object.keys(o.s).forEach(function (k) { scores[k] += o.s[k]; });
      });
      var ranked = ORDER.slice().sort(function (a, b) {
        return (scores[b] - scores[a]) || (ORDER.indexOf(a) - ORDER.indexOf(b));
      });
      this.result = { top: ranked[0], next: ranked[1], fmt: fmt };

      if (this.dataset.email === 'true' && this.$('.ssq__form')) this.show('email');
      else this.showResult();
    }

    pickProduct(scentId, fmt) {
      var byKey = this.products[SCENTS[scentId].key] || {};
      if (byKey[fmt] && byKey[fmt].available) return byKey[fmt];
      for (var i = 0; i < FALLBACK.length; i++) {
        var p = byKey[FALLBACK[i]];
        if (p && p.available) return p;
      }
      return byKey[fmt] || byKey.spray || byKey.set || byKey.oil || byKey.solid || null;
    }

    showResult() {
      var r = this.result;
      if (!r) return;
      var S = SCENTS[r.top];
      var N = SCENTS[r.next];
      var p = this.pickProduct(r.top, r.fmt);
      var np = this.pickProduct(r.next, 'spray');
      var fmtName = p ? FMT_NAME[p.fmt] : FMT_NAME[r.fmt];
      var url = p ? p.url : '/collections/all';
      var nurl = np ? np.url : '/collections/all';

      var fmtLine = '';
      if (p && p.available) fmtLine = 'Start with the ' + esc(fmtName) + ', ' + esc(p.price) + '.';
      else if (p) fmtLine = 'The ' + esc(fmtName) + ' is sold out right now.';

      this.$('[data-ssq-result]').innerHTML =
        '<div class="ssq__card" style="--accent:' + S.color + '">' +
          '<div class="ssq__media">' + (p && p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(S.name) + '" loading="lazy">' : '') + '</div>' +
          '<div class="ssq__body">' +
            '<p class="ssq__kicker">Your scent</p>' +
            '<h2 class="ssq__name" tabindex="-1">' + esc(S.name) + '</h2>' +
            '<span class="ssq__swatch" aria-hidden="true"></span>' +
            '<p class="ssq__meta">' + esc(S.meta) + '</p>' +
            '<p class="ssq__moment">' + esc(S.moment) + '</p>' +
            (fmtLine ? '<p class="ssq__fmt">' + fmtLine + '</p>' : '') +
            '<a class="ssq__btn" href="' + esc(url) + '">' + (p && p.available ? 'Shop the ' + esc(fmtName) : 'View ' + esc(S.name)) + '</a>' +
            '<p class="ssq__also">Also worth trying: <a href="' + esc(nurl) + '">' + esc(N.name) + '</a></p>' +
            '<button type="button" class="ssq__link" data-ssq-retake>Retake the quiz</button>' +
          '</div>' +
        '</div>';

      this.show('result');
      var h = this.$('.ssq__name');
      if (h) h.focus({ preventScroll: true });
    }
  }

  customElements.define('ss-quiz', SsQuiz);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'shopify_wishlist';

    function getList() {
      try {
        var raw = localStorage.getItem(KEY);
        var parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) { return []; }
    }
    function saveList(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    function updateHeaderCount() {
      var count = getList().length;
      ['wishlist-header-count', 'wishlist-header-count-mob'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        el.textContent = count;
        el.style.setProperty('display', 'flex', 'important');
      });
    }

    function cardUrl(url) {
      if (!url) return null;
      var clean = url.split('#')[0];
      return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'view=ss-card';
    }

    function setCount(root, n) {
      var el = root.querySelector('[data-ssw-count]');
      if (el) el.textContent = n === 1 ? '1 product' : n + ' products';
      var empty = root.querySelector('[data-ssw-empty]');
      if (empty) empty.hidden = n > 0;
      if (el) el.hidden = n === 0;
    }

    function watchHeart(root, li) {
      var btn = li.querySelector('.ss-card__wish');
      if (!btn || !window.MutationObserver) return;
      new MutationObserver(function () {
        if (btn.getAttribute('aria-pressed') === 'false') {
          li.classList.add('is-removing');
          setTimeout(function () {
            li.remove();
            setCount(root, root.querySelectorAll('.ssw__item').length);
          }, 250);
        }
      }).observe(btn, { attributes: true, attributeFilter: ['aria-pressed'] });
    }

    function render(root) {
      var grid = root.querySelector('[data-ssw-grid]');
      if (!grid) return;
      var list = getList();
      grid.innerHTML = '';
      setCount(root, list.length);
      if (!list.length) return;

      list.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'ssw__item ssw__item--loading';
        li.innerHTML = '<div class="ssw__ph-img"></div><div class="ssw__ph-line"></div>';
        grid.appendChild(li);

        var url = cardUrl(item.url);
        if (!url) { li.remove(); return; }

        fetch(url, { credentials: 'same-origin' })
          .then(function (r) {
            if (r.status === 404) {
              /* Product was removed or unpublished: drop it from the saved list */
              saveList(getList().filter(function (p) { return String(p.id) !== String(item.id); }));
              updateHeaderCount();
              throw new Error('gone');
            }
            return r.text();
          })
          .then(function (html) {
            li.classList.remove('ssw__item--loading');
            li.innerHTML = html;
            if (window.ssCardSync) window.ssCardSync();
            watchHeart(root, li);
          })
          .catch(function () {
            li.remove();
            setCount(root, root.querySelectorAll('.ssw__item').length);
          });
      });
    }

    function init() {
      document.querySelectorAll('.ssw').forEach(function (root) {
        if (root.dataset.sswReady) return;
        root.dataset.sswReady = '1';
        render(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        document.querySelectorAll('.ssw').forEach(function (root) { render(root); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
